import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Login from '../pages/Login/index';
import { authLoader } from "@/utils/authLoader";
import SystemLayout from '@/components/Layout';
import DefaultTbNavigate from '@/components/Navigate'
import ErrorBoundary from '@/components/ErrorBoundary'
import {
  UserOutlined,
  SettingOutlined,
  ShoppingOutlined,
  ShopOutlined,
  GiftOutlined,
  VideoCameraOutlined,
  PlaySquareOutlined,
  HeartOutlined,
  SnippetsOutlined,
  WechatOutlined,
  ApiOutlined,
  TagOutlined,
  AppstoreOutlined,
  FileTextOutlined
} from '@ant-design/icons';

const TaobaoKeywordPcList = lazy(() => import('../pages/PcList/TaoPcList'));
const TaobaoKeywordAppList = lazy(() => import('../pages/TaobaoKeywordAppList'));
const TaobaoImageList = lazy(() => import('../pages/TaobaoImageList'));
const TaobaoImageAppList = lazy(() => import('../pages/TaobaoImageAppList'));
const TaobaoMobileSearch = lazy(() => import('../pages/MobileSearch'));
const DeviceManagementPage = lazy(() => import('../pages/Setting/DeviceManagementPage'));
const UsersManagementPage = lazy(() => import('../pages/Users/UserList/UserManagement'));
const RolesManagementPage = lazy(() => import('../pages/Users/RolesList/RoleManagement'));
const TaskInfoData = lazy(() => import('../pages/TaskData'));
const JDdataParse = lazy(() => import('../pages/DataParsing/jd-data-parsing'));
const TaodataParse = lazy(() => import('../pages/DataParsing/tao-data-parsing'));
const PdddataParse = lazy(() => import('../pages/DataParsing/pdd-data-parsing'));
const KuaishouSearchUser = lazy(() => import('../pages/DataParsing/kuaishou-user-search'));
const KuaishouSearchVideo = lazy(() => import('../pages/DataParsing/kuaishou-video-search'));
const KuaishouProfileVideo = lazy(() => import('../pages/DataParsing/kuaishou-profile-data'));
const WeiStoreGoods = lazy(() => import('../pages/WeChat/WeiStoreGoods'));
const KuaishouShopList = lazy(() => import('../pages/Kuaishou/KuaishouShopList'));
const PcDetail = lazy(() => import('../pages/PcDetail/Pcdetail'));
const JdPcDetail = lazy(() => import('../pages/PcDetail/JdPcDetail'));
const JdPclist = lazy(() => import('../pages/PcList/JdPclist'));
const TaoShopList = lazy(() => import('../pages/PcShop/TaoShop'));
const ClientCheck = lazy(() => import('../pages/ClientCheck'));
const DouyinShareLink = lazy(() => import('../pages/DouyinShareLink'));
const DouyinKouling = lazy(() => import('../pages/DouyinKouling'));
const JdShareLink = lazy(() => import('../pages/JdShareLink'));
const TbShareLink = lazy(() => import('../pages/TbShareLink'));
const WechatSphInfo = lazy(() => import('../pages/WechatSphInfo'));
const XianyuUserParse = lazy(() => import('../pages/XianyuUserParse'));
const TaobaoHtmlDetail = lazy(() => import('../pages/TaobaoHtmlDetail'));
const AppShopList = lazy(() => import('../pages/AppShopList'));
const XiaohongshuDataParse = lazy(() => import('../pages/DataParsing/xiaohongshu-data-parsing'));
const DouyinVideoList = lazy(() => import('../pages/VideoList/douyin'));
const DouyinUserList = lazy(() => import('../pages/UserList/douyin'));
const ImageWatermark = lazy(() => import('../pages/ImageWatermark'));
const ClientLoginLog = lazy(() => import('../pages/ClientLoginLog'));
/**
 * handle:{//自配置属性
 *    title 菜单标题展示
 *    icon 图标展示
 *    path children内的path 使用在匹配接口返回得路由得
 *
 * }
 * loader 验证是否有token
 */
const allRouter =
  [
    {
      path: '/',
      // 访问 "/" 时直接重定向到 "/login"
      // element: <SystemLayout/>,
      element: <DefaultTbNavigate />,
      errorElement: <ErrorBoundary />
    },
    {
      path: '/login',
      handle: { title: "登录", },
      element: <Login />,
    },
    {
      path: '/tb',
      element: <SystemLayout />,
      errorElement: <ErrorBoundary />,
      loader: authLoader,
      handle: { title: "淘宝", icon: <ShoppingOutlined /> },
      children: [{
        index: true, // 索引路由，当路径正好是 /tb 时匹配
        element: <Navigate to="taobao-keyword" replace />, // 动态重定向, // 重定向
      },

      {
        path: 'taobao-app-keyword',
        handle: { title: "关键词APP列表", group: '淘宝', path: 'tb' },
        element: <TaobaoKeywordAppList />,
      },
      {
        path: 'taobao-app-image',
        handle: { title: "图搜APP列表", group: '淘宝', path: 'tb' },
        element: <TaobaoImageAppList />,
      }, {
        path: 'taobao-keyword',
        handle: { title: "PC商品列表", group: '淘宝', path: 'tb', },
        element: <TaobaoKeywordPcList />,
      }, {
        path: 'taobao-detail',
        handle: { title: "PC商品详情", group: '淘宝', path: 'tb' },
        element: <PcDetail />,
      }, {
        path: 'taobao-shop',
        handle: { title: "PC商品店铺", group: '淘宝', path: 'tb' },
        element: <TaoShopList />,
      }, {
        path: 'taobao-mobile-search',
        handle: { title: "APP列表中转", group: '淘宝', path: 'tb' },
        element: <TaobaoMobileSearch />,
      },
        // {
        //   path: 'taobao-keyword-data-list',
        //   handle: { title: "关键词数据列表", group: '淘宝', path: 'tb' },
        //   element: <TaobaoKeywordDataList />,
        // },
        // {
        //   path: 'taobao-image-data-list',
        //   handle: { title: "图搜数据列表", group: '淘宝', path: 'tb' },
        //   element: <JDPcListData />,
        // }
      ]
    },
    {
      path: '/jd',
      handle: { title: "京东", icon: <ShopOutlined /> },
      element: <SystemLayout />,
      loader: authLoader,
      children: [
        {
          index: true, // 索引路由，当路径正好是 /jd 时匹配
          element: <Navigate to="jd-keyword" replace />, // 重定向
        },
        {
          path: 'jd-app-keyword',
          handle: { title: "关键词APP列表", group: '京东', path: 'sys-jd-app-kw' },
          element: <TaobaoKeywordAppList />,
        },
        {
          path: 'jd-app-image',
          handle: { title: "图搜APP列表", group: '京东', path: 'sys-jd-app-img' },
          element: <TaobaoImageAppList />,
        }, {
          path: 'jd-keyword',
          handle: { title: "PC商品列表", group: '京东', path: 'sys-jd-pc-kw' },
          element: <JdPclist />,
        }, {
          path: 'jd-detail',
          handle: { title: "PC商品详情", group: '京东', path: 'jd-detail' },
          element: <JdPcDetail />,
        }, {
          path: 'jd-mobile-search',
          handle: { title: "APP列表中转", group: '京东', path: 'sys-jd-mobile-search' },
          element: <TaobaoMobileSearch />,
        },
        // {
        //   path: 'jd-keyword-data-list',
        //   handle: { title: "关键词数据列表", group: '京东', path: 'jd' },
        //   element: <TaobaoKeywordDataList />,
        // },
        // {
        //   path: 'jd-image-data-list',
        //   handle: { title: "图搜数据列表", group: '京东', path: 'jd' },
        //   element: <JDPcListData />,
        // }
      ]
    },
    {
      path: '/pdd',
      handle: { title: "拼多多", icon: <GiftOutlined /> },
      element: <SystemLayout />,
      loader: authLoader,
      children: [
        {
          index: true, // 索引路由，当路径正好是 /pdd 时匹配
          element: <Navigate to="pdd-keyword" replace />, // 重定向
        }, {
          path: 'pdd-keyword',
          handle: { title: "关键词PC列表", group: '拼多多' },
          element: <TaobaoKeywordPcList />,
        },
        {
          path: 'pdd-app-keyword',
          handle: { title: "关键词APP列表", group: '拼多多' },
          element: <TaobaoKeywordAppList />,
        },
        {
          path: 'pdd-image',
          handle: { title: "图搜PC列表", group: '拼多多' },
          element: <TaobaoImageList />,
        }, {
          path: 'pdd-app-image',
          handle: { title: "图搜APP列表", group: '拼多多' },
          element: <TaobaoImageAppList />,
        }]
    },
    {
      path: '/dy',
      handle: { title: "抖音", icon: <VideoCameraOutlined /> },
      element: <SystemLayout />,
      loader: authLoader,
      children: [
        {
          index: true, // 索引路由，当路径正好是 /douyin 时匹配
          element: <Navigate to="dy-app-keyword" replace />, // 重定向
        },
        {
          path: 'dy-app-keyword',
          handle: { title: "关键词APP列表", group: '抖音', path: 'sys-dy-app-kw' },
          element: <TaobaoKeywordAppList />,
        },
        {
          path: 'dy-app-image',
          handle: { title: "图搜APP列表", group: '抖音', path: 'sys-dy-app-img' },
          element: <TaobaoImageAppList />,
        },
        {
          path: 'dy-app-shop',
          handle: { title: "店铺APP列表", group: '抖音', path: 'sys-dy-app-shop' },
          element: <AppShopList />,
        },
        {
          path: 'dy-mobile-search',
          handle: { title: "APP店铺中转", group: '抖音', path: 'sys-dy-mobile-search' },
          element: <TaobaoMobileSearch />,
        },
        {
          path: 'dy-mobile-search-list',
          handle: { title: "APP列表中转", group: '抖音', path: 'sys-dy-mobile-search-list' },
          element: <TaobaoMobileSearch />,
        },
        {
          path: 'dy-video-list',
          handle: { title: "视频列表", group: '抖音', path: 'sys-dy-video-list' },
          element: <DouyinVideoList />,
        }, {
          path: 'dy-user-list',
          handle: { title: "用户列表", group: '抖音', path: 'sys-dy-user-list' },
          element: <DouyinUserList />,
        },
      ]
    },
    {
      path: '/kuaishou',
      handle: { title: "快手", icon: <PlaySquareOutlined /> },
      element: <SystemLayout />,
      loader: authLoader,
      children: [
        {
          index: true, // 索引路由，当路径正好是 /kuaishou 时匹配
          element: <Navigate to="kuaishou-keyword" replace />, // 重定向
        },
        {
          path: 'kuaishou-keyword',
          handle: { title: "关键词PC列表", group: '快手' },
          element: <TaobaoKeywordPcList />,
        },
        {
          path: 'kuaishou-app-keyword',
          handle: { title: "关键词APP列表", group: '快手' },
          element: <TaobaoKeywordAppList />,
        },
        {
          path: 'kuaishou-image',
          handle: { title: "图搜PC列表", group: '快手' },
          element: <TaobaoImageList />,
        }, {
          path: 'kuaishou-app-image',
          handle: { title: "图搜APP列表", group: '快手' },
          element: <TaobaoImageAppList />,
        }, {
          path: 'kuaishou-shop-list',
          handle: { title: "快手店铺列表", group: '快手' },
          element: <KuaishouShopList />,
        }]
    },
    {
      path: '/xiaohongshu',
      handle: { title: "小红书", icon: <HeartOutlined /> },
      element: <SystemLayout />,
      loader: authLoader,
      children: [
        {
          index: true, // 索引路由，当路径正好是 /xiaohongshu 时匹配
          element: <Navigate to="xiaohongshu-keyword" replace />, // 重定向
        },
        {
          path: 'xiaohongshu-keyword',
          handle: { title: "关键词PC列表", group: '小红书' },
          element: <TaobaoKeywordPcList />,
        },
        {
          path: 'xiaohongshu-app-keyword',
          handle: { title: "关键词APP列表", group: '小红书' },
          element: <TaobaoKeywordAppList />,
        },
        {
          path: 'xiaohongshu-image',
          handle: { title: "图搜PC列表", group: '小红书' },
          element: <TaobaoImageList />,
        }, {
          path: 'xiaohongshu-app-image',
          handle: { title: "图搜APP列表", group: '小红书' },
          element: <TaobaoImageAppList />,
        }, {
          path: 'xiaohongshu-mobile-search',
          handle: { title: "APP列表中转", group: '小红书', path: 'sys-xhs-mobile-search' },
          element: <TaobaoMobileSearch />,
        },]
    },
    {
      path: '/xianyu',
      handle: { title: "闲鱼", icon: <TagOutlined /> },
      element: <SystemLayout />,
      loader: authLoader,
      children: [
        {
          index: true,
          element: <Navigate to="xianyu-app-image" replace />,
        },
        {
          path: 'xianyu-app-image',
          handle: { title: "图搜APP列表", group: '闲鱼', path: 'sys-xy-app-img' },
          element: <TaobaoImageAppList />,
        },
        {
          path: 'xianyu-app-keyword',
          handle: { title: "关键词APP列表", group: '闲鱼', path: 'sys-xy-app-kw' },
          element: <TaobaoKeywordAppList />,
        },
        {
          path: 'xianyu-mobile-search',
          handle: { title: "APP列表中转", group: '闲鱼', path: 'sys-xy-mobile-search' },
          element: <TaobaoMobileSearch />,
        },
        // {
        //   path: 'xianyu-app-shop',
        //   handle: { title: "店铺APP列表", group: '闲鱼', path: 'sys-xy-app-shop' },
        //   element: <AppShopList />,
        // },
      ]
    },
    {
      path: '/dewu',
      handle: { title: "得物", icon: <AppstoreOutlined /> },
      element: <SystemLayout />,
      loader: authLoader,
      children: [
        {
          index: true,
          element: <Navigate to="dewu-mobile-search" replace />,
        },
        {
          path: 'dewu-mobile-search',
          handle: { title: "APP列表中转", group: '得物', path: 'sys-dewu-mobile-search' },
          element: <TaobaoMobileSearch />,
        },
      ],
    },

    {
      path: '/wechat',
      handle: { title: "微信", icon: <WechatOutlined /> },

      element: <SystemLayout />,
      loader: authLoader,
      children: [
        {
          index: true, // 索引路由，当路径正好是 /xiaohongshu 时匹配
          element: <Navigate to="wechat-stroe" replace />, // 重定向
        },
        {
          path: 'wechat-stroe',
          handle: { title: "PC微信小店详情", group: '微信' },
          element: <WeiStoreGoods />,
        },
      ]
    },
    {
      path: '/weidian',
      handle: { title: "微店", icon: <ShopOutlined /> },
      element: <SystemLayout />,
      loader: authLoader,
      children: [
        {
          index: true,
          element: <Navigate to="weidian-app-keyword" replace />,
        },
        {
          path: 'weidian-app-keyword',
          handle: { title: "关键词APP列表", group: '微店', path: 'sys-weidian-app-kw' },
          element: <TaobaoKeywordAppList />,
        },
        {
          path: 'weidian-mobile-search',
          handle: { title: "APP列表中转", group: '微店', path: 'sys-weidian-mobile-search' },
          element: <TaobaoMobileSearch />,
        },
      ],
    },
    {
      path: '/setting',
      handle: { title: "系统设置", icon: <SettingOutlined /> },
      element: <SystemLayout />,
      loader: authLoader,
      children: [
        {
          index: true, // 索引路由，当路径正好是 /setting 时匹配
          element: <Navigate to="device-management" replace />, // 重定向
        },
        {
          path: 'device-management',
          handle: { title: "设备管理", group: '系统设置', path: 'sys-device-manage' },
          element: <DeviceManagementPage />,
        }],
    },
    {
      path: '/users',
      element: <SystemLayout />,
      handle: { title: "用户管理", icon: <UserOutlined /> },
      loader: authLoader,
      children: [
        {
          index: true, // 索引路由，当路径正好是 /users 时匹配
          element: <Navigate to="users-list" replace />, // 重定向
        },
        {
          path: 'users-list',
          handle: { title: "用户管理", group: '用户', path: "sys-resource-add" },
          element: <UsersManagementPage />,
        }, {
          path: 'roles-list',
          handle: { title: "角色管理", group: '用户', path: "sys-resource-add" },
          element: <RolesManagementPage />,
        }],
    },
    {
      path: '/data-task',
      element: <SystemLayout />,
      handle: { title: "任务管理", icon: <SnippetsOutlined /> },
      loader: authLoader,
      children: [
        {
          index: true, // 索引路由，当路径正好是 /data-task 时匹配
          element: <Navigate to="task-list" replace />, // 重定向
        },
        {
          path: 'task-list',
          handle: { title: "任务列表", group: '任务管理', },
          element: <TaskInfoData />,
        }],
    },
    {
      path: '/data-audit',
      element: <SystemLayout />,
      handle: { title: "数据审核", icon: <SnippetsOutlined /> },
      loader: authLoader,
      children: [
        {
          index: true, // 索引路由，当路径正好是 /data-task 时匹配
          element: <Navigate to="tao-data-parse" replace />, // 重定向
        },
        {
          path: 'tao-data-parse',
          handle: { title: "淘宝数据审核", group: '数据审核', path: 'tao-data-parse' },
          element: <TaodataParse />,
        }, {
          path: 'jd-data-parse',
          handle: { title: "京东数据审核", group: '数据审核', path: 'jd-data-parse' },
          element: <JDdataParse />,
        }, {
          path: 'pdd-data-parse',
          handle: { title: "拼多多数据审核", group: '数据审核', path: 'pdd-data-parse' },
          element: <PdddataParse />,
        }, {
          path: 'kuaishou-search-user-parse',
          handle: { title: "快手搜索数据-用户", group: '数据审核', path: 'kuaishou-search-user-parse' },
          element: <KuaishouSearchUser />,
        }, {
          path: 'kuaishou-search-video-parse',
          handle: { title: "快手搜索数据-视频", group: '数据审核', path: 'kuaishou-search-video-parse' },
          element: <KuaishouSearchVideo />,
        }, {
          path: 'kuaishou-profile-video-parse',
          handle: { title: "快手主页数据-视频", group: '数据审核', path: 'kuaishou-profile-video-parse' },
          element: <KuaishouProfileVideo />,
        },
        // {
        //   path: 'xiaohongshu-data-parse',
        //   handle: { title: "小红书数据审核", group: '数据审核', path: 'xiaohongshu-data-parse' },
        //   element: <XiaohongshuDataParse />,
        // }
      ],
    },
    {
      path: '/tools',
      handle: { title: "工具", icon: <ApiOutlined /> },
      element: <SystemLayout />,
      loader: authLoader,
      children: [
        {
          index: true,
          element: <Navigate to="client-check" replace />,
        },
        {
          path: 'client-check',
          handle: { title: "客户端通信检查", group: '工具', path: 'sys-client-check' },
          element: <ClientCheck />,
        },
        {
          path: 'douyin-share-link',
          handle: { title: "抖音分享链接解析", group: '工具', path: 'sys-dy-share-link' },
          element: <DouyinShareLink />,
        },
        {
          path: 'douyin-kouling',
          handle: { title: "抖音口令转换", group: '工具', path: 'sys-dy-kouling' },
          element: <DouyinKouling />,
        },
        {
          path: 'jd-share-link',
          handle: { title: "京东分享链接解析", group: '工具', path: 'sys-jd-share-link' },
          element: <JdShareLink />,
        },
        {
          path: 'tb-share-link',
          handle: { title: "淘系短链接解析", group: '工具', path: 'sys-tb-share-link' },
          element: <TbShareLink />,
        },
        {
          path: 'wechat-sph-info',
          handle: { title: "微信视频号解析", group: '工具', path: 'sys-wechat-sph-info' },
          element: <WechatSphInfo />,
        },
        {
          path: 'xianyu-user-parse',
          handle: { title: "闲鱼用户解析", group: '工具', path: 'sys-xy-user-parse' },
          element: <XianyuUserParse />,
        },
        {
          path: 'taobao-html-detail',
          handle: { title: "淘宝详情HTML解析", group: '工具', path: 'sys-tb-html-detail' },
          element: <TaobaoHtmlDetail />,
        },
        {
          path: 'image-watermark',
          handle: { title: "图片水印生成", group: '工具', path: 'sys-image-watermark' },
          element: <ImageWatermark />,
        },
      ],
    },
    {
      path: '/client-log',
      handle: { title: "客户端上报日志", icon: <FileTextOutlined /> },
      element: <SystemLayout />,
      loader: authLoader,
      children: [
        {
          index: true,
          element: <Navigate to="report" replace />,
        },
        {
          path: 'report',
          handle: { title: "上报日志", group: '客户端上报日志' },
          element: <ClientLoginLog />,
        },
      ],
    },
    {
      // 通配符路由：捕获所有未匹配的路由，跳转到首页
      path: '*',
      element: <DefaultTbNavigate />,
      errorElement: <ErrorBoundary />
    }

  ]

export default allRouter;
